import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import appointmentService from "../../services/appointmentService";

const AppointmentReAddModal = (props) => {
  const { buttonLabel, className, appointmentId } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const confirmReAdd = () => {
    const aid = { appointmentId: appointmentId, userId: "" };
    appointmentService.reAddAppointment(aid).then(() => {
      props.refreshMonth();
      toggle();
    });
  };

  return (
    <div>
      <Button
        type="button"
        color="primary"
        disabled={props.disabled}
        className="btn btn-sm"
        onClick={toggle}
      >
        {buttonLabel}
      </Button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Re-Add appointment?</ModalHeader>
        <ModalBody>Are you sure you want to re-add this appointment?</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={props.disabled}
            onClick={confirmReAdd}
          >
            Re-Add
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AppointmentReAddModal;
